import React from 'react';
import Tophead from '../templates/tophead';
function Payment(){
    return(
      <div>
         <Tophead/>
         dfghrty6546546
      </div>
    )
}
export default Payment;